<template>
  <v-dialog v-model="dialog" persistent width="680px">
    <v-card>
      <v-card-title class="font-weight-bold ma-3">
        {{ title ? title : $t("StockOrderOUT.Messages.ErrorMaterialsAlert") }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 text-center subtitle-1">
        <v-data-table
          :headers="headers"
          :items="materialArr"
          :items-per-page="5"
          class="my-4"
          no-data-text=""
          dense
        >
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="accent" outlined depressed @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/i18n";
export default {
  name: "ErrorMaterialsAlert",

  props: {
    value: Boolean,
    title: String,
    materialArr: Array,
  },

  computed: {
    headers: () => {
      return [
        {
          text: i18n.t("StockOrderOUT.DetailFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("StockOrderOUT.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("StockOrderOUT.DetailFields.material_name"),
          align: "start",
          value: "material_name",
        },
      ];
    },
  },

  data: () => ({
    dialog: false,
  }),

  watch: {
    value: {
      immediate: true,
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) this.$emit("close");
      },
    },
  },
};
</script>